var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import { musicContextList, MusicContextProvider } from './music-context';
import { soundContextList, SoundContextProvider } from './sound-context';
export var audioContextList = __spreadArray(__spreadArray([], musicContextList), soundContextList);
export var AudioContextProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(MusicContextProvider, null,
        React.createElement(SoundContextProvider, null, children)));
};
